import { render, staticRenderFns } from "./evidenceType.vue?vue&type=template&id=277971d0&scoped=true"
import script from "./evidenceType.vue?vue&type=script&lang=js"
export * from "./evidenceType.vue?vue&type=script&lang=js"
import style0 from "./evidenceType.vue?vue&type=style&index=0&id=277971d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277971d0",
  null
  
)

export default component.exports